import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { WorkflowResultsDetailsResponse } from "@idw-types/data/workflow-results-details";

export const getWorkflowResultsDetailsRequest = async (
    queryParameters: Array<QueryParameter>
): Promise<{ data: WorkflowResultsDetailsResponse, error: any }> => {
    const route = apiRoutes.reports.workflowUsageDetails.workflowResultsDetails;

    const { data, error }: { data?: WorkflowResultsDetailsResponse, error?: any } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error };
};